export default function isReturnExpired(expiresAt: string) {
  const timeSinceExpiry = Date.now() - Date.parse(expiresAt);
  return timeSinceExpiry > 0;
}
